module.exports = __webpack_public_path__ + "media/app/assets/imgs/landing_2025/icon-note-2529962e2961dc969a0d9d29475e800a.png";